/* eslint-disable */
import { useState, useEffect } from "react";
import { LayoutDashboard, ClipboardList, CarFront, UserRound, Hourglass, MessagesSquare } from "lucide-react";
import {
  auth, db, functions, httpsCallable, ADMIN_EMAILS, ADMIN_UIDS,
  collection, query, where, doc, updateDoc, getDoc, getDocs, orderBy, limit, Timestamp, onSnapshot, writeBatch,
  signInWithEmailAndPassword, sendPasswordResetEmail,
} from "./firebase";
import {
  TEAL,GOLD,GREEN,RED,WARN,BG,WHITE,TEXT,SUB,LIGHT,DC,
  Btn,Inp,Card,Bar,Wrap,Sec,Tag,StarDisplay,TabBar,Empty,StatusBadge,InterestTags,
  formatDate,formatTime,formatDateTime,
} from "./components";

const ADMIN_GENDER_LABEL={male:"男",female:"女",other:"其他"};

const Admin=({onBack})=>{
  const [loggedIn,setLoggedIn]=useState(false);
  const [email,setEmail]=useState("");
  const [password,setPassword]=useState("");
  const [tab,setTab]=useState("dashboard");
  const [orders,setOrders]=useState([]);
  const [drivers,setDrivers]=useState([]);
  const [passengers,setPassengers]=useState([]);
  const [loading,setLoading]=useState(false);
  const [filter,setFilter]=useState("all");
  const [driverFilter,setDriverFilter]=useState("all");
  const [selectedOrder,setSelectedOrder]=useState(null);
  const [selectedDriver,setSelectedDriver]=useState(null);
  const [selectedPassenger,setSelectedPassenger]=useState(null);
  const [chatMessages,setChatMessages]=useState([]);
  const [chatOrderId,setChatOrderId]=useState(null);
  const [userSearch,setUserSearch]=useState("");
  const [communityPosts,setCommunityPosts]=useState([]);
  const [orderDateFilter,setOrderDateFilter]=useState("");

  useEffect(()=>{
    const unsub=auth.onAuthStateChanged(user=>{
      const byEmail=!!user?.email&&ADMIN_EMAILS.includes(user.email);
      const byUid=!!user?.uid&&ADMIN_UIDS.includes(user.uid);
      if(user&&(byEmail||byUid)){
        setLoggedIn(true);setEmail(user.email);
      }
    });
    return()=>unsub();
  },[]);

  const loadOrders=async()=>{
    setLoading(true);
    try{
      let q;
      if(filter==="all") q=query(collection(db,"orders"),orderBy("createdAt","desc"),limit(100));
      else q=query(collection(db,"orders"),where("status","==",filter),orderBy("createdAt","desc"),limit(100));
      const snap=await getDocs(q);
      setOrders(snap.docs.map(d=>({id:d.id,...d.data()})));
    }catch(e){console.error(e);}
    setLoading(false);
  };

  const loadDrivers=async()=>{
    setLoading(true);
    try{
      let q;
      if(driverFilter==="all") q=query(collection(db,"drivers"),orderBy("submittedAt","desc"));
      else q=query(collection(db,"drivers"),where("status","==",driverFilter));
      const snap=await getDocs(q);
      setDrivers(snap.docs.map(d=>({id:d.id,...d.data(),
        avgRating:d.data().ratingCount>0?(d.data().totalRating/d.data().ratingCount).toFixed(1):"N/A",
      })));
    }catch(e){console.error(e);}
    setLoading(false);
  };

  const loadPassengers=async()=>{
    setLoading(true);
    try{
      const q=query(collection(db,"passengers"),orderBy("createdAt","desc"),limit(100));
      const snap=await getDocs(q);
      setPassengers(snap.docs.map(d=>({id:d.id,...d.data()})));
    }catch(e){console.error(e);}
    setLoading(false);
  };

  const loadCommunityPosts=async()=>{
    setLoading(true);
    try{
      const q=query(collection(db,"community_posts"),orderBy("createdAt","desc"),limit(120));
      const snap=await getDocs(q);
      setCommunityPosts(snap.docs.map(d=>({id:d.id,...d.data()})));
    }catch(e){console.error(e);}
    setLoading(false);
  };

  const loadChatMessages=async(orderId)=>{
    setChatOrderId(orderId);
    try{
      const q=query(collection(db,"chats",orderId,"messages"),orderBy("createdAt","asc"));
      const snap=await getDocs(q);
      setChatMessages(snap.docs.map(d=>({id:d.id,...d.data()})));
    }catch(e){console.error(e);setChatMessages([]);}
  };

  useEffect(()=>{
    if(!loggedIn)return;
    if(tab==="orders")loadOrders();
    else if(tab==="drivers")loadDrivers();
    else if(tab==="passengers")loadPassengers();
    else if(tab==="community")loadCommunityPosts();
    else if(tab==="dashboard"){loadOrders();loadDrivers();loadPassengers();}
  },[loggedIn,tab,filter,driverFilter]);

  const approveDriver=async(id)=>{
    try{
      await updateDoc(doc(db,"drivers",id),{status:"approved",approvedAt:Timestamp.now()});
      alert("✅ 已批准");loadDrivers();
    }catch(e){alert("❌ 失敗");}
  };

  const rejectDriver=async(id)=>{
    const reason=prompt("拒絕原因：");
    if(!reason)return;
    try{
      await updateDoc(doc(db,"drivers",id),{status:"rejected",rejectReason:reason});
      alert("❌ 已拒絕");loadDrivers();
    }catch(e){alert("❌ 失敗");}
  };

  const cancelOrder=async(id)=>{
    if(!window.confirm("確定取消呢個Carpool？"))return;
    try{
      await updateDoc(doc(db,"orders",id),{status:"cancelled",cancelledBy:"admin",cancelledAt:Timestamp.now()});
      loadOrders();
    }catch(e){alert("❌ 失敗");}
  };

  const tripleConfirm=(msg)=>{
    if(!window.confirm(`${msg}\n\n第 1 次確認`))return false;
    if(!window.confirm(`${msg}\n\n第 2 次確認`))return false;
    if(!window.confirm(`${msg}\n\n最後確認（第 3 次）`))return false;
    return true;
  };

  const deleteUserRecord=async(role,u)=>{
    const label=role==="driver"?"車主":"乘客";
    const name=u?.name||u?.email||u?.phone||u?.id;
    if(!tripleConfirm(`你將永久刪除${label}帳戶：${name}\n（會刪 Firestore + Auth 帳戶）`))return;
    try{
      const fn=httpsCallable(functions,"adminDeleteUserFully");
      await fn({
        uid: u.id,
        role,
        email: (u?.email || "").trim().toLowerCase(),
      });
      alert(`✅ 已刪除${label}帳戶（含 Auth）`);
      if(role==="driver")loadDrivers();
      else loadPassengers();
      if(role==="driver")setSelectedDriver(null);
      else setSelectedPassenger(null);
    }catch(e){alert("刪除失敗："+e.message);}
  };

  const norm=s=>(s||"").toString().trim().toLowerCase();
  const matchesUserSearch=u=>{
    const q=norm(userSearch);
    if(!q)return true;
    return [u?.name,u?.email,u?.phone,u?.plate].some(v=>norm(v).includes(q));
  };

  const orderDateKey=ts=>{
    if(!ts?.seconds)return "未有日期";
    const d=new Date(ts.seconds*1000);
    return d.toISOString().slice(0,10);
  };

  const deleteCommunityPost=async p=>{
    if(!tripleConfirm(`刪除社區貼文（${p.authorName||"匿名"}）？`))return;
    try{
      const likes=await getDocs(collection(db,"community_posts",p.id,"likes"));
      const comments=await getDocs(collection(db,"community_posts",p.id,"comments"));
      const batch=writeBatch(db);
      likes.docs.forEach(d=>batch.delete(d.ref));
      comments.docs.forEach(d=>batch.delete(d.ref));
      batch.delete(doc(db,"community_posts",p.id));
      await batch.commit();
      loadCommunityPosts();
    }catch(e){alert("刪除貼文失敗："+e.message);}
  };

  const StatCard=({icon,Icon,label,value,color=TEAL})=>(
    <div style={{background:WHITE,borderRadius:14,padding:"16px 14px",border:`1px solid ${LIGHT}`,
      textAlign:"center",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
      <div style={{marginBottom:6,display:"flex",justifyContent:"center",alignItems:"center",minHeight:32}}>
        {Icon?<Icon size={28} strokeWidth={2.2} color={color} aria-hidden/>:<span style={{fontSize:24}}>{icon}</span>}
      </div>
      <div style={{color,fontSize:22,fontWeight:900}}>{value}</div>
      <div style={{color:SUB,fontSize:14,marginTop:2}}>{label}</div>
    </div>
  );

  const InfoRow=({label,value,color=TEXT})=>(
    <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:`1px solid ${LIGHT}`}}>
      <span style={{color:SUB,fontSize:16}}>{label}</span>
      <span style={{color,fontSize:16,fontWeight:500,maxWidth:"60%",textAlign:"right",wordBreak:"break-all"}}>{value||"N/A"}</span>
    </div>
  );

  if(!loggedIn)return(
    <div style={{minHeight:"100vh",background:BG}}>
      <Bar title="管理員登入" onBack={onBack}/>
      <Wrap>
        <Card style={{textAlign:"center",padding:24}}>
          <div style={{fontSize:48,marginBottom:12}}>🔧</div>
          <p style={{color:TEXT,fontWeight:700,fontSize:18,marginBottom:4}}>八達Go 管理後台</p>
          <p style={{color:SUB,fontSize:16,marginBottom:16}}>只限管理員登入</p>
        </Card>
        <Sec title="管理員電郵">
          <Card>
            <Inp placeholder="admin@8go.ca" value={email} onChange={e=>setEmail(e.target.value)} type="email"/>
            <Inp placeholder="密碼" value={password} onChange={e=>setPassword(e.target.value)} type="password"/>
            <p style={{textAlign:"right",margin:"4px 0 0",color:TEAL,fontSize:15,cursor:"pointer",fontWeight:600}}
              onClick={async()=>{
                const emailTrimmed=(email||"").trim().toLowerCase();
                if(!emailTrimmed){alert("請先輸入管理員電郵");return;}
                try{
                  const resetResults=await Promise.allSettled([
                    sendPasswordResetEmail(auth,emailTrimmed),
                    (async()=>{
                      const fn=httpsCallable(functions,"sendCustomPasswordResetEmailV1");
                      await fn({email:emailTrimmed});
                    })(),
                  ]);
                  const resetSent=resetResults.some(r=>r.status==="fulfilled");
                  if(!resetSent){
                    const reason=resetResults
                      .filter(r=>r.status==="rejected")
                      .map(r=>r.reason?.code||r.reason?.message||"unknown")
                      .join(" | ");
                    throw new Error(`all reset channels failed: ${reason}`);
                  }
                  alert("✅ 已發送重設密碼電郵，請檢查 Inbox / Spam。");
                }catch(err){
                  if(err.code==="auth/user-not-found")alert("❌ 帳戶唔存在");
                  else if(err.code==="auth/invalid-email")alert("❌ 電郵格式唔正確");
                  else alert("❌ 發送失敗："+err.message);
                }
              }}>
              忘記密碼？重設電郵密碼
            </p>
          </Card>
        </Sec>
        <Btn label="登入" onClick={async()=>{
          try{
            const uc=await signInWithEmailAndPassword(auth,email,password);
            const byEmail=!!uc.user.email&&ADMIN_EMAILS.includes(uc.user.email);
            const byUid=!!uc.user.uid&&ADMIN_UIDS.includes(uc.user.uid);
            if(!(byEmail||byUid)){alert("❌ 你唔係管理員");auth.signOut();return;}
            setLoggedIn(true);
          }catch(err){alert("❌ 登入失敗："+err.message);}
        }}/>
      </Wrap>
    </div>
  );

  // ── CHAT LOG VIEW ──────────────────────────────────────────────────
  if(chatOrderId)return(
    <div style={{minHeight:"100vh",background:BG}}>
      <Bar title={`聊天紀錄 #${chatOrderId.substring(0,6)}`} onBack={()=>{setChatOrderId(null);setChatMessages([]);}}/>
      <Wrap>
        {chatMessages.length===0?(
          <Empty icon="💬" msg="冇聊天紀錄"/>
        ):(
          chatMessages.map((m,i)=>(
            <div key={i} style={{marginBottom:8}}>
              <div style={{display:"flex",gap:8,alignItems:"flex-start"}}>
                <div style={{width:32,height:32,borderRadius:"50%",background:m.senderRole==="driver"?TEAL+"22":"#EDE9FE",
                  display:"flex",alignItems:"center",justifyContent:"center",fontSize:17,flexShrink:0}}>
                  {m.senderRole==="driver"?"🚗":"👤"}
                </div>
                <div style={{flex:1}}>
                  <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:2}}>
                    <span style={{color:TEXT,fontSize:16,fontWeight:600}}>{m.senderName||"未知"}</span>
                    <Tag label={m.senderRole==="driver"?"車主":"乘客"} color={m.senderRole==="driver"?TEAL:"#7C3AED"}/>
                    <span style={{color:SUB,fontSize:16,marginLeft:"auto"}}>{m.createdAt?formatDateTime(m.createdAt):""}</span>
                  </div>
                  <div style={{background:WHITE,borderRadius:12,padding:"8px 12px",border:`1px solid ${LIGHT}`,
                    fontSize:17,color:TEXT,lineHeight:1.5}}>{m.text}</div>
                </div>
              </div>
            </div>
          ))
        )}
      </Wrap>
    </div>
  );

  // ── ORDER DETAIL ───────────────────────────────────────────────────
  if(selectedOrder){
    const o=selectedOrder;
    return(
      <div style={{minHeight:"100vh",background:BG}}>
        <Bar title={`Carpool #${o.id.substring(0,6)}`} onBack={()=>setSelectedOrder(null)}/>
        <Wrap>
          <Card>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:12}}>
              <StatusBadge status={o.status}/>
              <span style={{color:SUB,fontSize:15}}>{formatDateTime(o.createdAt)}</span>
            </div>
            <Sec title="乘客資料">
              <div style={{background:DC,borderRadius:12,padding:14}}>
                <InfoRow label="姓名" value={o.passengerName}/>
                <InfoRow label="電話" value={o.phone}/>
                <InfoRow label="ID" value={o.passengerId?.substring(0,12)+"..."}/>
              </div>
            </Sec>
            <Sec title="行程資料">
              <div style={{background:DC,borderRadius:12,padding:14}}>
                <InfoRow label="📍 上車" value={o.pickup}/>
                {o.stops?.map((s,i)=><InfoRow key={i} label={`📌 中途站${i+1}`} value={s.address}/>)}
                <InfoRow label="🏁 目的地" value={o.dest}/>
              </div>
            </Sec>
            <Sec title="詳情">
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                <Tag label={`👥 ${o.pax}人`} color={TEAL}/>
                {o.distKm!=null&&o.distKm!==""?<Tag label={`📏 ${o.distKm}km`} color={SUB}/>:<Tag label={`💬 ${o.fare||"—"}`} color={TEAL}/>}
                {o.hasChild&&<Tag label="👶 有細路" color={GOLD}/>}
                {o.hasPet&&<Tag label="🐾 有寵物" color={WARN}/>}
                {o.isScheduled&&<Tag label={`📅 預約 ${formatDateTime(o.scheduledTime)}`} color="#818CF8"/>}
                <Tag label={o.matchMode==="fast"?"⚡快速":"👀自選"} color={SUB}/>
              </div>
            </Sec>
            {o.driverName&&(
              <Sec title="車主資料">
                <div style={{background:DC,borderRadius:12,padding:14}}>
                  <InfoRow label="姓名" value={o.driverName}/>
                  <InfoRow label="車牌" value={o.driverPlate}/>
                  <InfoRow label="車型" value={o.driverVtype}/>
                  <InfoRow label="電話" value={o.driverPhone}/>
                  <InfoRow label="評分" value={o.rating?`${o.rating}⭐`:"未評"} color={o.rating?GOLD:SUB}/>
                </div>
              </Sec>
            )}
            <div style={{display:"flex",gap:8}}>
              <Btn label="💬 查看聊天紀錄" color={TEAL} style={{flex:1}} onClick={()=>loadChatMessages(o.id)}/>
              {o.status==="waiting"&&(
                <Btn label="取消" color={RED} style={{flex:1}} onClick={()=>{cancelOrder(o.id);setSelectedOrder(null);}}/>
              )}
            </div>
          </Card>
        </Wrap>
      </div>
    );
  }

  // ── DRIVER DETAIL (simplified: license only) ───────────────────────
  if(selectedDriver){
    const d=selectedDriver;
    return(
      <div style={{minHeight:"100vh",background:BG}}>
        <Bar title={d.name} onBack={()=>setSelectedDriver(null)}/>
        <Wrap>
          <Card>
            <div style={{textAlign:"center",marginBottom:16}}>
              <div style={{width:80,height:80,borderRadius:"50%",background:DC,overflow:"hidden",
                display:"flex",alignItems:"center",justifyContent:"center",fontSize:36,margin:"0 auto 12px",border:`2px solid ${LIGHT}`}}>
                {d.selfieURL?<img src={d.selfieURL} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>:"👤"}
              </div>
              <p style={{color:TEXT,fontWeight:700,fontSize:18,margin:"0 0 4px"}}>{d.name}</p>
              <StarDisplay rating={parseFloat(d.avgRating)||0} count={d.ratingCount||0}/>
              <div style={{marginTop:6}}><StatusBadge status={d.status}/></div>
            </div>

            <Sec title="基本資料">
              <div style={{background:DC,borderRadius:12,padding:14}}>
                <InfoRow label="車牌" value={d.plate}/>
                <InfoRow label="車型" value={d.vehicleType}/>
                <InfoRow label="性別" value={d.gender?ADMIN_GENDER_LABEL[d.gender]||d.gender:"—"}/>
                <InfoRow label="語言" value={(d.langs||[]).join(", ")}/>
                <InfoRow label="電話" value={d.phone}/>
                <InfoRow label="電郵" value={d.email}/>
                <InfoRow label="職業" value={d.occupation||"未填"}/>
                <InfoRow label="提交時間" value={formatDateTime(d.submittedAt)}/>
              </div>
            </Sec>

            {(d.occupation||d.expertise?.length>0||d.hobbies?.length>0)&&(
              <Sec title="☕ Coffee Chat 興趣">
                <InterestTags occupation={d.occupation} expertise={d.expertise||[]} hobbies={d.hobbies||[]}/>
              </Sec>
            )}

            {d.bio&&<Sec title="簡介"><Card><p style={{color:TEXT,fontSize:16,margin:0}}>{d.bio}</p></Card></Sec>}

            <Sec title="偏好">
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                <Tag label={d.acceptChild?"👶 接細路":"👶 唔接細路"} color={d.acceptChild?GREEN:RED}/>
                <Tag label={d.acceptPet?"🐾 接寵物":"🐾 唔接寵物"} color={d.acceptPet?GREEN:RED}/>
              </div>
            </Sec>

            <Sec title="文件">
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {(d.licenseFrontURL||d.licenseURL)&&<a href={d.licenseFrontURL||d.licenseURL} target="_blank" rel="noreferrer"
                  style={{flex:"1 1 140px",minWidth:120,background:DC,borderRadius:10,padding:12,textAlign:"center",textDecoration:"none",color:TEAL,fontSize:15,fontWeight:600}}>🪪 駕照正面</a>}
                {d.licenseBackURL&&<a href={d.licenseBackURL} target="_blank" rel="noreferrer"
                  style={{flex:"1 1 140px",minWidth:120,background:DC,borderRadius:10,padding:12,textAlign:"center",textDecoration:"none",color:TEAL,fontSize:15,fontWeight:600}}>🪪 駕照背面</a>}
              </div>
            </Sec>

            {d.status==="pending"&&(
              <div style={{display:"flex",gap:8}}>
                <Btn label="✅ 批准" color={GREEN} style={{flex:1}} onClick={()=>{approveDriver(d.id);setSelectedDriver(null);}}/>
                <Btn label="❌ 拒絕" color={RED} style={{flex:1}} onClick={()=>{rejectDriver(d.id);setSelectedDriver(null);}}/>
              </div>
            )}
            <Btn label="🗑️ 刪除車主資料（3次確認）" color={RED} style={{marginTop:10}}
              onClick={()=>deleteUserRecord("driver",{id:d.id,...d})}/>
          </Card>
        </Wrap>
      </div>
    );
  }

  // ── PASSENGER DETAIL ───────────────────────────────────────────────
  if(selectedPassenger){
    const p=selectedPassenger;
    return(
      <div style={{minHeight:"100vh",background:BG}}>
        <Bar title={p.name||"乘客"} onBack={()=>setSelectedPassenger(null)}/>
        <Wrap>
          <Card>
            <div style={{textAlign:"center",marginBottom:16}}>
              <div style={{width:80,height:80,borderRadius:"50%",background:DC,overflow:"hidden",
                display:"flex",alignItems:"center",justifyContent:"center",fontSize:36,margin:"0 auto 12px",border:`2px solid ${LIGHT}`}}>
                {p.avatarURL?<img src={p.avatarURL} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>:"👤"}
              </div>
              <p style={{color:TEXT,fontWeight:700,fontSize:18,margin:"0 0 4px"}}>{p.name}</p>
            </div>
            <Sec title="聯絡資料">
              <div style={{background:DC,borderRadius:12,padding:14}}>
                <InfoRow label="電郵" value={p.email}/>
                <InfoRow label="電話" value={p.phone}/>
                <InfoRow label="職業" value={p.occupation||"未填"}/>
                <InfoRow label="註冊日期" value={formatDateTime(p.createdAt)}/>
              </div>
            </Sec>
            {(p.occupation||p.expertise?.length>0||p.hobbies?.length>0)&&(
              <Sec title="☕ Coffee Chat 興趣">
                <InterestTags occupation={p.occupation} expertise={p.expertise||[]} hobbies={p.hobbies||[]}/>
              </Sec>
            )}
            <Sec title="帳戶資料">
              <div style={{background:DC,borderRadius:12,padding:14,marginBottom:10}}>
                <InfoRow label="頻繁取消警告（次）" value={String(p.frequentCancelWarnings??0)}/>
                <InfoRow label="帳戶暫停至" value={p.accountSuspendedUntil?formatDateTime(p.accountSuspendedUntil):"—"}/>
              </div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                <Tag label={`推薦碼: ${p.referralCode||"N/A"}`} color={TEAL}/>
                {p.cancelCount>0&&<Tag label={`取消次數: ${p.cancelCount}`} color={RED}/>}
              </div>
            </Sec>
            <Btn label="🗑️ 刪除乘客資料（3次確認）" color={RED} style={{marginTop:10}}
              onClick={()=>deleteUserRecord("passenger",{id:p.id,...p})}/>
          </Card>
        </Wrap>
      </div>
    );
  }

  // ── MAIN DASHBOARD ─────────────────────────────────────────────────
  return(
    <div style={{minHeight:"100vh",background:BG}}>
      <Bar title="八達Go 管理後台" onBack={()=>{auth.signOut();onBack();}}
        right={<span style={{color:SUB,fontSize:14}}>{email}</span>}/>
      <TabBar tabs={[
        {key:"dashboard",Icon:LayoutDashboard,label:"概覽"},
        {key:"orders",Icon:ClipboardList,label:"Carpool"},
        {key:"drivers",Icon:CarFront,label:"車主"},
        {key:"passengers",Icon:UserRound,label:"乘客"},
        {key:"community",Icon:MessagesSquare,label:"社區"},
      ]} active={tab} onChange={setTab}/>

      <Wrap>
        {tab==="dashboard"&&<>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
            <StatCard Icon={ClipboardList} label="總Carpool" value={orders.length} color={TEAL}/>
            <StatCard Icon={CarFront} label="車主" value={drivers.length} color={GREEN}/>
            <StatCard Icon={UserRound} label="乘客" value={passengers.length} color="#7C3AED"/>
            <StatCard Icon={Hourglass} label="待審核" value={drivers.filter(d=>d.status==="pending").length} color={WARN}/>
          </div>

          <Sec title="最近Carpool">
            {orders.slice(0,5).map(o=>(
              <Card key={o.id} style={{cursor:"pointer"}} onClick={()=>{setSelectedOrder(o);setTab("orders");}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <span style={{color:TEXT,fontSize:15,fontWeight:600}}>#{o.id.substring(0,6)}</span>
                    <span style={{color:SUB,fontSize:15,marginLeft:8}}>{o.passengerName}</span>
                  </div>
                  <StatusBadge status={o.status}/>
                </div>
              </Card>
            ))}
          </Sec>

          {drivers.filter(d=>d.status==="pending").length>0&&(
            <Sec title="⏳ 待審核車主">
              {drivers.filter(d=>d.status==="pending").map(d=>(
                <Card key={d.id} style={{cursor:"pointer"}} onClick={()=>{setSelectedDriver(d);setTab("drivers");}}>
                  <div style={{display:"flex",gap:12,alignItems:"center"}}>
                    <div style={{width:40,height:40,borderRadius:"50%",background:DC,overflow:"hidden",
                      display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,border:`2px solid ${LIGHT}`}}>
                      {d.selfieURL?<img src={d.selfieURL} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>:"👤"}
                    </div>
                    <div style={{flex:1}}>
                      <p style={{color:TEXT,fontWeight:600,fontSize:17,margin:0}}>{d.name}</p>
                      <span style={{color:SUB,fontSize:15}}>{d.plate} · {d.vehicleType}</span>
                    </div>
                    <div style={{display:"flex",gap:4}}>
                      <button onClick={e=>{e.stopPropagation();approveDriver(d.id);}}
                        style={{background:GREEN,color:WHITE,border:"none",borderRadius:8,padding:"6px 10px",fontSize:15,cursor:"pointer"}}>✅</button>
                      <button onClick={e=>{e.stopPropagation();rejectDriver(d.id);}}
                        style={{background:RED,color:WHITE,border:"none",borderRadius:8,padding:"6px 10px",fontSize:15,cursor:"pointer"}}>❌</button>
                    </div>
                  </div>
                </Card>
              ))}
            </Sec>
          )}
        </>}

        {tab==="orders"&&<>
          <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:12}}>
            {[["all","全部"],["waiting","等待中"],["awaiting_passenger","待乘客確認"],["awaiting_driver","待車主確認"],["scheduled_pending","預約待出發"],["grabbed","已配對"],["completed","已完成"],["cancelled","已取消"]].map(([v,l])=>(
              <div key={v} onClick={()=>setFilter(v)} style={{
                padding:"6px 12px",borderRadius:20,fontSize:15,cursor:"pointer",
                background:filter===v?TEAL:DC,color:filter===v?WHITE:SUB,fontWeight:600}}>
                {l}
              </div>
            ))}
          </div>
          <Card>
            <p style={{color:SUB,fontSize:14,margin:"0 0 6px"}}>按日期篩選（留空=全部）</p>
            <input type="date" value={orderDateFilter} onChange={e=>setOrderDateFilter(e.target.value)}
              style={{width:"100%",padding:"10px 12px",borderRadius:10,border:`1px solid ${LIGHT}`,fontSize:16}}/>
          </Card>
          {loading?<div style={{textAlign:"center",padding:40,fontSize:30,animation:"go-spin 1s linear infinite"}}>🔄</div>:
          (()=> {
            const filtered=orders.filter(o=>!orderDateFilter||orderDateKey(o.createdAt)===orderDateFilter);
            if(filtered.length===0)return <Empty msg="冇Carpool"/>;
            const grouped=filtered.reduce((acc,o)=>{
              const k=orderDateKey(o.createdAt);
              if(!acc[k])acc[k]=[];
              acc[k].push(o);
              return acc;
            },{});
            const keys=Object.keys(grouped).sort((a,b)=>a>b?-1:1);
            return keys.map(k=>(
              <Sec key={k} title={`📅 ${k} · 共 ${grouped[k].length} 單`}>
                {grouped[k].map(o=>(
                  <Card key={o.id} style={{cursor:"pointer"}} onClick={()=>setSelectedOrder(o)}>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                      <span style={{color:TEXT,fontSize:15,fontWeight:600}}>#{o.id.substring(0,6)}</span>
                      <StatusBadge status={o.status}/>
                    </div>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
                      <span style={{color:SUB,fontSize:15}}>👤 {o.passengerName}</span>
                      <span style={{color:SUB,fontSize:14}}>{formatDateTime(o.createdAt)}</span>
                    </div>
                    <p style={{color:TEXT,fontSize:15,margin:"0 0 2px"}}>📍 {(o.pickup||"").substring(0,40)}...</p>
                    <p style={{color:TEXT,fontSize:15,margin:0}}>🏁 {(o.dest||"").substring(0,40)}...</p>
                    <div style={{display:"flex",gap:4,marginTop:6}}>
                      {o.distKm!=null&&o.distKm!==""?<Tag label={`📏 ${o.distKm}km`} color={SUB}/>:<Tag label={`💬 ${o.fare||"—"}`} color={TEAL}/>}
                      {o.driverName&&<Tag label={`🚗 ${o.driverName}`} color={SUB}/>}
                      {o.isScheduled&&<Tag label="📅 預約" color="#818CF8"/>}
                    </div>
                  </Card>
                ))}
              </Sec>
            ));
          })()
          }
          <Btn label="🔄 重新載入" color={DC} textColor={SUB} style={{boxShadow:"none",border:`1px solid ${LIGHT}`}} onClick={loadOrders}/>
        </>}

        {tab==="drivers"&&<>
          <Card>
            <Inp placeholder="搜尋車主：姓名 / 電話 / 電郵 / 車牌" value={userSearch} onChange={e=>setUserSearch(e.target.value)}/>
          </Card>
          <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:12}}>
            {[["all","全部"],["pending","待審核"],["approved","已批准"],["rejected","已拒絕"]].map(([v,l])=>(
              <div key={v} onClick={()=>setDriverFilter(v)} style={{
                padding:"6px 12px",borderRadius:20,fontSize:15,cursor:"pointer",
                background:driverFilter===v?TEAL:DC,color:driverFilter===v?WHITE:SUB,fontWeight:600}}>
                {l} {v==="pending"&&drivers.filter(d=>d.status==="pending").length>0?
                  `(${drivers.filter(d=>d.status==="pending").length})`:""}
              </div>
            ))}
          </div>
          {loading?<div style={{textAlign:"center",padding:40,fontSize:30,animation:"go-spin 1s linear infinite"}}>🔄</div>:
          drivers.filter(matchesUserSearch).length===0?<Empty msg="冇車主"/>:
          drivers.filter(matchesUserSearch).map(d=>(
            <Card key={d.id} style={{cursor:"pointer"}} onClick={()=>setSelectedDriver(d)}>
              <div style={{display:"flex",gap:12,alignItems:"center"}}>
                <div style={{width:48,height:48,borderRadius:"50%",background:DC,overflow:"hidden",
                  display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,border:`2px solid ${LIGHT}`}}>
                  {d.selfieURL?<img src={d.selfieURL} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>:"👤"}
                </div>
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <p style={{color:TEXT,fontWeight:600,fontSize:17,margin:0}}>{d.name}</p>
                    <StatusBadge status={d.status}/>
                  </div>
                  <div style={{color:SUB,fontSize:15,marginTop:2}}>{d.plate} · {d.vehicleType}</div>
                  {d.occupation&&<div style={{color:GOLD,fontSize:14,marginTop:1}}>💼 {d.occupation}</div>}
                  <div style={{marginTop:3}}><StarDisplay rating={parseFloat(d.avgRating)||0} count={d.ratingCount||0} size={11}/></div>
                </div>
                {d.status==="pending"&&(
                  <div style={{display:"flex",gap:4}}>
                    <button onClick={e=>{e.stopPropagation();approveDriver(d.id);}}
                      style={{background:GREEN,color:WHITE,border:"none",borderRadius:8,padding:"6px 10px",fontSize:15,cursor:"pointer"}}>✅</button>
                    <button onClick={e=>{e.stopPropagation();rejectDriver(d.id);}}
                      style={{background:RED,color:WHITE,border:"none",borderRadius:8,padding:"6px 10px",fontSize:15,cursor:"pointer"}}>❌</button>
                  </div>
                )}
              </div>
            </Card>
          ))}
          <Btn label="🔄 重新載入" color={DC} textColor={SUB} style={{boxShadow:"none",border:`1px solid ${LIGHT}`}} onClick={loadDrivers}/>
        </>}

        {tab==="passengers"&&<>
          <Card>
            <Inp placeholder="搜尋乘客：姓名 / 電話 / 電郵" value={userSearch} onChange={e=>setUserSearch(e.target.value)}/>
          </Card>
          {loading?<div style={{textAlign:"center",padding:40,fontSize:30,animation:"go-spin 1s linear infinite"}}>🔄</div>:
          passengers.filter(matchesUserSearch).length===0?<Empty msg="冇乘客"/>:
          passengers.filter(matchesUserSearch).map(p=>(
            <Card key={p.id} style={{cursor:"pointer"}} onClick={()=>setSelectedPassenger(p)}>
              <div style={{display:"flex",gap:12,alignItems:"center"}}>
                <div style={{width:48,height:48,borderRadius:"50%",background:DC,overflow:"hidden",
                  display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,border:`2px solid ${LIGHT}`}}>
                  {p.avatarURL?<img src={p.avatarURL} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>:"👤"}
                </div>
                <div style={{flex:1}}>
                  <p style={{color:TEXT,fontWeight:600,fontSize:17,margin:0}}>{p.name}</p>
                  {p.occupation&&<div style={{color:GOLD,fontSize:14}}>💼 {p.occupation}</div>}
                  <div style={{color:SUB,fontSize:15}}>📱 {p.phone||"N/A"}</div>
                </div>
                <div style={{textAlign:"right"}}>
                  <span style={{color:SUB,fontSize:16}}>{formatDate(p.createdAt)}</span>
                  <div style={{color:TEAL,fontSize:15,marginTop:4}}>→</div>
                </div>
              </div>
            </Card>
          ))}
          <Btn label="🔄 重新載入" color={DC} textColor={SUB} style={{boxShadow:"none",border:`1px solid ${LIGHT}`}} onClick={loadPassengers}/>
        </>}

        {tab==="community"&&<>
          {loading?<div style={{textAlign:"center",padding:40,fontSize:30,animation:"go-spin 1s linear infinite"}}>🔄</div>:
          communityPosts.length===0?<Empty msg="冇社區貼文"/>:
          communityPosts.map(p=>(
            <Card key={p.id}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
                <div>
                  <p style={{color:TEXT,fontWeight:700,fontSize:16,margin:0}}>{p.authorName||"匿名"}</p>
                  <p style={{color:SUB,fontSize:14,margin:0}}>{formatDateTime(p.createdAt)}</p>
                </div>
                <Btn label="🗑️ 刪除貼文（3次確認）" color={RED} onClick={()=>deleteCommunityPost(p)}/>
              </div>
              <p style={{color:TEXT,fontSize:16,lineHeight:1.5,margin:"10px 0 0",whiteSpace:"pre-wrap"}}>{p.text}</p>
            </Card>
          ))}
          <Btn label="🔄 重新載入" color={DC} textColor={SUB} style={{boxShadow:"none",border:`1px solid ${LIGHT}`}} onClick={loadCommunityPosts}/>
        </>}
      </Wrap>
    </div>
  );
};

export default Admin;
